import React from "react";
import { Link, useLocation } from "react-router-dom";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/booking", label: "Booking" },
  { to: "/#contact", label: "Contact" },
];

export default function SiteNav({ transparent = false }) {
  const { pathname } = useLocation();
  return (
    <nav
      className={`fixed top-0 left-0 z-40 flex w-full items-center justify-between px-6 py-6 md:px-12 ${
        transparent ? "" : "border-b border-white/10 bg-[#0a0a0a]/80 backdrop-blur-md"
      }`}
    >
      <Link to="/" className="font-serif-lux text-lg tracking-[0.25em] text-white" data-testid="nav-brand">
        AMANI
      </Link>
      <div className="flex items-center gap-6 text-[11px] uppercase tracking-[0.25em] text-white/60 md:gap-8">
        {links.map((l) =>
          l.to.startsWith("/#") ? (
            <a key={l.label} href={l.to} className="transition-colors hover:text-white" data-testid={`nav-${l.label.toLowerCase()}`}>
              {l.label}
            </a>
          ) : (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`transition-colors hover:text-white ${pathname === l.to ? "text-white" : ""}`}
            >
              {l.label}
            </Link>
          )
        )}
      </div>
    </nav>
  );
}
